import { render, staticRenderFns } from "./CategoryImporterView.vue?vue&type=template&id=b607643c&"
import script from "./CategoryImporterView.vue?vue&type=script&lang=js&"
export * from "./CategoryImporterView.vue?vue&type=script&lang=js&"
import style0 from "./CategoryImporterView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports